import Vue from 'vue'
import axios from 'axios'
import 'alpinejs'

window.pingping = {
    csrfToken: document.head.querySelector('meta[name="csrf-token"]').content,
}

Vue.prototype.$http = window.axios = axios.create({
    headers: {
        'X-CSRF-TOKEN': window.pingping.csrfToken,
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
})

Vue.component('pricing', require('./components/Pricing.vue').default)

Vue.config.errorHandler = function (err, vm, info) {
    console.error(err)
}

new Vue({
    el: '#marketing',

    data() {
        return {}
    },
})
